export { default as TruncatedList } from './src/truncated-list';
